import { price, rate, bucket, type Segment } from "../../shared/price.ts";

/** Owner rows come with the full parameters (03-architecture.md: owners receive `l`). */
export type OwnerRow = {
  id: string;
  title: string;
  status: "draft" | "scheduled" | "active" | "sold_out" | "expired" | "cancelled";
  start_price: number | null;
  floor_price: number;
  start_at: number | null;
  end_at: number | null;
  duration_s: number | null;
  quantity: number;
  quantity_remaining: number;
  watch_count: number;
  alert_count: number;
  is_drop: number | boolean;
  cover: string | null;
};

/** Builds a segment locally from owner parameters so the dashboard ticks without polling per row. */
export function ownerSegment(r: OwnerRow, now: number): Segment | null {
  if (r.start_price === null || r.start_at === null || r.duration_s === null) return null;
  const l = {
    start_price: r.start_price,
    floor_price: r.floor_price,
    start_at: r.start_at,
    duration_s: r.duration_s,
  };
  return {
    price: price(l, now),
    rate_per_s: rate(l),
    server_ts: now,
    bucket: bucket(l, now),
    qty_remaining: r.quantity_remaining,
    status: r.status,
  };
}
